import React from 'react';
import { useIntl } from 'react-intl';

import { AllTranslationKeys } from '../../../shared/intl/types';
import { WorkloadStatus } from '../types';

interface WorkloadStatusProps {
    workloadStatus: WorkloadStatus;
}

export const WorkloadStatusComponent: React.FC<WorkloadStatusProps> = ({ workloadStatus }) => {
    const intl = useIntl();
    const statusTranslationKey: AllTranslationKeys = `agent_settings.workload_status.${workloadStatus}`;
    return (
        <span style={{ fontSize: `16px`, marginRight: `14px`, fontWeight: `600` }}>
            {intl.formatMessage({ id: 'agent_settings.workload_status.label' })}
            {': '}
            {intl.formatMessage({
                id: statusTranslationKey,
            })}
        </span>
    );
};
